import React from "react";
import "./Applicant.css";
import { MDBDataTable } from "mdbreact";
import Table from "react-bootstrap/Table";
import config4 from "../Util/config";
import { getToken } from "../Util/Authenticate";
import axios from "axios";
import { Link } from "react-router-dom";
import { DeleteTab } from "../Requests/mutators";
import URLconfig from "../Util/URLConfig";

const Listoftabs = () => {
  const [tabs, setTabs] = React.useState([]);
  const [isLoading, setisLoading] = React.useState(true);
  const GetTabs = () => {
    var data = "";
    var config = {
      method: "post",
      url: `${config4.BASE_URL}/api/Admin/GetallTabs`,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        //console.log("Tabs API", JSON.stringify(response.data));
        setTabs(response.data);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };
  const onSubmit = async (id) => {
    try {
      setisLoading(true);
      await DeleteTab(id);
      setisLoading(false);
      alert("Operation Occured Successfully");
      //window.location.href = `${URLconfig.BASE_URL}Policies/#/dashboard`;
      window.location.reload();
      //window.location.href = `http://localhost:3000/#/dashboard`;
    } catch (err) {
      setisLoading(false);
      alert(err, "Error while Updating, Please Try Again");
    }
  };
  React.useEffect(() => {
    GetTabs();
  }, []);
  const data = {
    columns: [
      {
        label: "#",
        field: "Number",
        sort: "asc",
      },
      {
        label: "Tab Name",
        field: "tabName",
        sort: "asc",
      },
      {
        label: "Active",
        field: "isAvaliable",
        sort: "asc",
      },
      {
        label: "Action",
        field: "action",
        sort: "asc",
      },
    ],
    rows: [
      ...tabs.map((data, i) => ({
        Number: i + 1,
        tabName: data.tabName,
        isAvaliable: data.isAvaliable == 1 ? "Active" : "Not Active",
        action: (
          <>
            <div className="d-flex">
              <div className="pr-2">
                <Link
                  to={{
                    pathname: "/TabDetails",
                    state: {
                      tabId: data.tabId,
                    },
                  }}
                >
                  <button type="button" class="btn btn-success">
                    Edit
                  </button>
                </Link>
              </div>
              <div className="pl-2">
                <Link>
                  <button
                    onClick={() => onSubmit(data.tabId)}
                    type="button"
                    class="btn btn-danger"
                  >
                    Delete
                  </button>
                </Link>
              </div>
            </div>
          </>
        ),
      })),
    ],
  };
  return (
    <div>
      {/* <h3 class="ButtonFrame">Available Courses | الدورات المتاحة</h3> */}
      <hr class="solid"></hr>
      <div>
        <div className="row">
          <div className="col-lg">
            <Link
              to={{
                pathname: "/AddnewTab",
              }}
            >
              <button type="button" class="btn btn-success col-2 mt-3">
                Add Tab
              </button>
            </Link>

            <Table responsive>
              <MDBDataTable
                className="text-left"
                striped
                bordered
                data={data}
                order={["Number", "asc"]}
                entries={10}
                hover
              />
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Listoftabs;
